<template>
    <div class="AppScreenshots">
      <section class="container-fluid screenshots mb-5" id="screenshots">
    <div class="container text-center pt-5">
      
        <h2 >App Screenshots</h2>
    
     
        <p class="lead">Most such devices are sold with several apps bundled as pre-installed software,
          such as a web browser, email client, calendar, mappindg program.</p>
      </div>
  
    <div id="carouselExampleControls" class="carousel slide text-center mt-3" data-ride="carousel" data-interval="3000">
      <div class="carousel-inner">
        <div class="carousel-item active">zz../assets/img/
          <div class="row pl-4">
            <div class="col"><img src="../assets/img/1.png" class="d-block img-fluid mx-auto" alt="..."></div>
            <div class="col d-none d-sm-block"><img src="../assets/img/2.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-md-block"><img src="../assets/img/3.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-lg-block"><img src="../assets/img/4.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-xl-block"><img src="../assets/img/5.png" class="d-block img-fluid" alt="..."></div>

          </div>

        </div>
        <div class="carousel-item">

          <div class="row pl-4">
            <div class="col"><img src="../assets/img/2.png" class="d-block img-fluid mx-auto" alt="..."></div>
            <div class="col d-none d-sm-block"><img src="../assets/img/3.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-md-block"><img src="../assets/img/4.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-lg-block"><img src="../assets/img/5.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-xl-block"><img src="../assets/img/1.png" class="d-block img-fluid" alt="..."></div>

          </div>
        </div>
        <div class="carousel-item">
          <div class="row pl-4">
            <div class="col"><img src="../assets/img/3.png" class="d-block img-fluid mx-auto" alt="..."></div>
            <div class="col d-none d-sm-block"><img src="../assets/img/4.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-md-block"><img src="../assets/img/5.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-lg-block"><img src="../assets/img/1.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-xl-block"><img src="../assets/img/2.png" class="d-block img-fluid" alt="..."></div>

          </div>
        </div>
        <div class="carousel-item">
          <div class="row pl-4">
            <div class="col"><img src="../assets/img/4.png" class="d-block img-fluid mx-auto" alt="..."></div>
            <div class="col d-none d-sm-block"><img src="../assets/img/5.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-md-block"><img src="../assets/img/1.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-lg-block"><img src="../assets/img/2.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-xl-block"><img src="../assets/img/3.png" class="d-block img-fluid" alt="..."></div>

          </div>
        </div>
        <div class="carousel-item">
          <div class="row pl-4">
            <div class="col"><img src="../assets/img/5.png" class="d-block img-fluid mx-auto" alt="..."></div>
            <div class="col d-none d-sm-block"><img src="../assets/img/1.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-md-block"><img src="../assets/img/2.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-lg-block"><img src="../assets/img/3.png" class="d-block img-fluid" alt="..."></div>
            <div class="col d-none d-xl-block"><img src="../assets/img/4.png" class="d-block img-fluid" alt="..."></div>

          </div>
        </div>
      </div>
      <div class="text-center mt-5"> <a href="#carouselExampleControls" data-slide="prev">
          <img src="../assets/img/left.png" alt="" class="prevNext">
        </a>
        <a href="#carouselExampleControls" data-slide="next">
          <img src="../assets/img/right.png" alt="" class="prevNext">
        </a>
      </div>
    </div>
  </section>

    </div>
</template>

<script>
export default {
  name: 'AppScreenshots',
  
}

</script>

<style scoped>

@import '../style.css';

.prevNext {
    transition: 0.2s ease;
}
.prevNext:hover {
    transform: scale(1.1);

}


</style>